module.exports = __webpack_public_path__ + "assets/a902950aa0081bc632441edf9830540c.png";